import * as _types from "../_constants/types";
import ws from "../_constants/webservices";

export const get = order_id => dispatch => {
    dispatch({ type: _types.ORDER_FETCHING });

    ws.shopify
        .get(`/public/orders/${order_id}?with_update=true`)
        .then(({ json, response }) => {
            dispatch({
                type: _types.ORDER_LOAD,
                results: json
            });
            dispatch({
                type: _types.ORDER_FETCHING_COMPLETED
            });
        })
        .catch(() => {
            // try fetching again if previous request failed
            ws.shopify
                .get(`/public/orders/${order_id}?with_update=true`)
                .then(({ json, response }) => {
                    dispatch({
                        type: _types.ORDER_FETCHING_COMPLETED
                    });
                    dispatch({
                        type: _types.ORDER_LOAD,
                        results: json
                    });
                })
                .catch((err, response) => {
                    dispatch({
                        type: _types.ORDER_FETCHING_FAILED,
                        err
                    });
                });
        });
};

export const reset = () => dispatch => {
    dispatch({ type: _types.ORDER_RESET });
};

export const generateInvoice = (order_id, language, additionalInfo) => dispatch => {
    dispatch({ type: _types.INVOICE_FETCHING });

    let url = `/public/orders/${order_id}/invoice`;

    var data = { language: language, additional_info: additionalInfo };

    ws.shopify
        .post(url, data)
        .then(({ json, response }) => {
            dispatch({
                type: _types.INVOICE_FETCHING_COMPLETED
            });
        })
        .catch(({ response }) => {
            dispatch({
                type: _types.INVOICE_FETCHING_FAILED,
                err: "Failed to generate an invoice"
            });
        });
};

export const cancelOrder = (orderId, cancelOrderData) => dispatch => {
    dispatch({ type: _types.ORDER_CANCEL_FETCHING });

    let url = `/public/orders/${orderId}/cancel`;

    ws.shopify
        .post(url, cancelOrderData)
        .then(({ json, response }) => {
            dispatch({
                type: _types.ORDER_CANCEL_FETCHING_COMPLETED
            });
        })
        .catch(({ response }) => {
            if (response && response.status && response.status === 409) {
                dispatch({ type: _types.ORDER_CANCEL_FETCHING_FAILED, err: "conflict" });
            } else {
                dispatch({ type: _types.ORDER_CANCEL_FETCHING_FAILED, err: "failed to cancel order" });
            }
        });
};

export const cancelOrderCalculate = (orderId, cancelOrderCalculateData) => dispatch => {
    dispatch({ type: _types.CANCEL_ORDER_CALCULATING });

    let url = `/public/orders/${orderId}/cancel/calculate`;

    ws.shopify
        .post(url, cancelOrderCalculateData)
        .then(({ json, response }) => {
            dispatch({
                type: _types.CANCEL_ORDER_CALCULATE_LOAD,
                data: json
            });
            dispatch({
                type: _types.CANCEL_ORDER_CALCULATING_COMPLETED
            });
        })
        .catch(({ response }) => {
            if (response && response.status && response.status === 409) {
                dispatch({ type: _types.CANCEL_ORDER_CALCULATING_FAILED, err: "conflict" });
            } else {
                dispatch({ type: _types.CANCEL_ORDER_CALCULATING_FAILED, err: "failed to calculate" });
            }
        });
};

export const cancelOrderCalculateReset = () => dispatch => {
    dispatch({ type: _types.CANCEL_ORDER_CALCULATE_RESET });
};

export const returnOrder = (orderId, returnOrderData, language) => dispatch => {
    dispatch({ type: _types.ORDER_RETURN_FETCHING });

    let url = `/public/orders/${orderId}/return?language=${language}`;

    ws.shopify
        .post(url, returnOrderData)
        .then(({ json, response }) => {
            dispatch({
                type: _types.ORDER_RETURN_FETCHING_COMPLETED
            });
        })
        .catch(({ response }) => {
            if (response && response.status && response.status === 409) {
                dispatch({ type: _types.ORDER_RETURN_FETCHING_FAILED, err: "conflict" });
            } else {
                dispatch({ type: _types.ORDER_RETURN_FETCHING_FAILED, err: "failed to return order" });
            }
        });
};

export const returnOrderCalculate = (orderId, returnOrderCalculateData) => dispatch => {
    dispatch({ type: _types.RETURN_ORDER_CALCULATING });

    let url = `/public/orders/${orderId}/return/calculate`;

    ws.shopify
        .post(url, returnOrderCalculateData)
        .then(({ json, response }) => {
            dispatch({
                type: _types.RETURN_ORDER_CALCULATE_LOAD,
                data: json
            });
            dispatch({
                type: _types.RETURN_ORDER_CALCULATING_COMPLETED
            });
        })
        .catch(({ response }) => {
            if (response && response.status && response.status === 409) {
                dispatch({ type: _types.RETURN_ORDER_CALCULATING_FAILED, err: "conflict" });
            } else {
                dispatch({ type: _types.RETURN_ORDER_CALCULATING_FAILED, err: "failed to calculate" });
            }
        });
};

export const returnOrderCalculateReset = () => dispatch => {
    dispatch({ type: _types.RETURN_ORDER_CALCULATE_RESET });
};

export const replaceOrder = (orderId, replaceOrderData, language) => dispatch => {
    dispatch({ type: _types.ORDER_REPLACE_FETCHING });

    let url = `/public/orders/${orderId}/replace?language=${language}`;

    ws.shopify
        .post(url, replaceOrderData)
        .then(({ json, response }) => {
            dispatch({
                type: _types.ORDER_REPLACE_FETCHING_COMPLETED
            });
        })
        .catch(({ response }) => {
            if (response && response.status && response.status === 409) {
                dispatch({ type: _types.ORDER_REPLACE_FETCHING_FAILED, err: "conflict" });
            } else {
                dispatch({ type: _types.ORDER_REPLACE_FETCHING_FAILED, err: "failed to replace order" });
            }
        });
};

export const sendEgiftCardsEmail = orderId => dispatch => {
    dispatch({ type: _types.EGIFTCARD_EMAIL_SENDING });

    let url = `/public/orders/${orderId}/send-egiftcards-email`;

    ws.shopify
        .get(url)
        .then(() => {
            dispatch({ type: _types.EGIFTCARD_EMAIL_SENDING_COMPLETED });
        })
        .catch(err => {
            dispatch({
                type: _types.EGIFTCARD_EMAIL_SENDING_FAILED,
                err
            });
        });
};



// WEBPACK FOOTER //
// ./src/_actions/order.js